<template>
  <div class="navcontainer _navcontainer">
    <div class="cardicon _cardicon" @click="$router.push('/home')">
      <i class="iconfont icon-gouwuche"></i>购买
    </div>
    <div class="shopcar" @click="$router.push('/searchOrder')">
      <i class="iconfont el-icon-search"></i>
      订单查询，提取卡密
    </div>
  </div>
</template>

<script>
export default {
  name: "navtop",
  components: {},
  data() {
    return {
      nalistshowflag: false,
    };
  },
  methods: {
    routerpush(to) {
      this.$router.push(to);
    },
  },
};
</script>

<style lang="less" scoped>
.iconfont {
  padding-right: 10px;
}
// 大于800px
@media only screen and (min-width: 800px) {
  .navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 40px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);
    .navicon {
      display: none;
      cursor: pointer;
    }
    .navicon:hover {
      color: white;
    }
    .cardicon {
      width: 100px;
      cursor: pointer;
    }
    .cardicon:hover {
      color: white;
    }
    .mainnavlist {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      .navlistclose {
        display: none;
      }
      div {
        text-align: center;
        height: 40px;
        line-height: 40px;
        width: 95px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
      }
      div:hover {
        color: white;
      }
    }
    .shopcar {
      // width: 100px;
      cursor: pointer;
    }
    .shopcar:hover {
      color: white;
    }
  }
}
// 小于800px
@media only screen and (max-width: 800px) {
  ._navcontainer {
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 40px;
    background-color: rgb(51, 51, 51);
    color: rgb(214, 214, 214);
    position: relative;
    ._navicon {
      width: 100px;
    }
    ._cardicon {
      width: 100px;
    }
    ._mainnavlist {
      display: flex;
      flex-direction: column;
      position: absolute;
      //屏幕宽度小于800，默认清空下菜单是关闭的
      display: none;
      position: fixed;
      left: 0;
      top: 0 !important;
      z-index: 1999 !important;
      padding-top: 40px !important;
      width: 100%;
      height: 100%;
      color: rgb(214, 214, 214);
      background-color: rgba(0, 0, 0, 0.95);
      top: 40px;
      padding: 0 40px;
      z-index: 999;
      div {
        text-align: left;
        height: 40px;
        line-height: 40px;
        width: 100%;
        border-bottom: 1px solid rgb(214, 214, 214);
      }
    }
    .shopcar {
      width: 100px;
    }
  }
  .navlistshow {
    display: block !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comcomponents/NavTop.vue